export default __webpack_public_path__ + "static/media/my-maor.ae8662a9.png";